module.exports = __webpack_public_path__ + "img/001_roundandround.503de35e.gif";